export default {"src":"/_next/static/media/unit_right_arrow.b210a470.svg","height":47,"width":29,"blurWidth":0,"blurHeight":0};